<template>
    <div class="data-sources">
        <tab-bar :tabs="tabs"></tab-bar>
        <router-view></router-view>
    </div>
</template>


<script type="text/javascript">
import { mapState } from 'vuex';
import TabBar from '../TabBar';
import store from '../../store.js';

export default {
  data () {
    return {
      tabs: {
      }
    };
  },
  components: {
    TabBar
  },
};
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/dataSource/DataSource.vue